// 모델 능력 판정 — **한 곳에서만** 한다.
//
// 🔴 2026-08-28: `심층` 지원 여부를 판정하는 정규식이 네 군데(ChatInput·useChatFeatures·
//    백엔드 2곳)에 복사돼 있었다. Fable 등급이 추가되자 prod 에서 선택은 되는데
//    심층 토글만 회색이 됐고, 토글을 눌러도 이펙트가 즉시 되돌렸다.
//    이제 능력은 **백엔드가 모델 목록에 실어 보낸다**(models_catalog.REASONING_UI 가 정본).
//    목록이 아직 없을 때만 옛 규칙으로 버틴다(토글이 깜빡이지 않게).

const FALLBACK_RE = /(^|-)(opus|sonnet|fable|haiku)(-|$)/;

export function supportsReasoning(models, modelId) {
  const m = (models || []).find((x) => x.id === modelId);
  if (m && typeof m.reasoning === 'boolean') return m.reasoning;
  return FALLBACK_RE.test(modelId || '');
}

export default supportsReasoning;
